import { render, staticRenderFns } from "./circle2.vue?vue&type=template&id=4add6b22&scoped=true&"
import script from "./circle2.vue?vue&type=script&lang=js&"
export * from "./circle2.vue?vue&type=script&lang=js&"
import style0 from "./circle2.vue?vue&type=style&index=0&id=4add6b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add6b22",
  null
  
)

export default component.exports